(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const image = section.querySelector('.syk-main-product-image');
      const buttons = section.querySelectorAll('[data-gallery-image]');
      const galleryBrand = section.querySelector('.syk-gallery-brand');
      const redesignedGallery = section.querySelector('[data-supporting-redesign="true"]');
      const dialog = document.querySelector('[data-image-dialog]');
      const sizedImage = (src, width) => {
        const url = new URL(src, window.location.href);
        if (/syk-(?:pdp|black|85)-.*\.webp$/i.test(url.pathname)) url.pathname = url.pathname.replace(/(?:-w\d+)?\.webp$/i, (width >= 1200 ? '' : '-w' + width) + '.webp');
        else if (/_(\d+)x(?=\.[a-z]+$)/i.test(url.pathname)) url.pathname = url.pathname.replace(/_(\d+)x(?=\.[a-z]+$)/i, '_' + width + 'x');
        else if (url.searchParams.has('width')) url.searchParams.set('width', width);
        else return src;
        return url.href;
      };
      const responsiveImage = (target, src, sizes) => {
        target.dataset.fullImage = src;
        target.src = sizedImage(src, 800);
        target.srcset = [400, 600, 800, 1254].map(width => sizedImage(src, width) + ' ' + width + 'w').join(', ');
        target.sizes = sizes;
      };
      const swap = (src, alt, id) => {
        if (image && src) { responsiveImage(image, src, '(min-width: 1440px) 724px, (min-width: 990px) 52vw, calc(100vw - 40px)'); if (alt) image.alt = alt; }
        if (galleryBrand && redesignedGallery) galleryBrand.hidden = id !== 'syk-hero';
        buttons.forEach(b => b.setAttribute('aria-pressed', String(id ? b.dataset.mediaId === String(id) : b.dataset.galleryImage === src)));
        const active = Array.from(buttons).find(b => b.getAttribute('aria-pressed') === 'true');
        const label = section.querySelector('[data-gallery-label]:not(button)');
        if (label && active) label.textContent = active.dataset.galleryLabel || 'Your selected configuration';
        const description = section.querySelector('[data-gallery-description]:not(button)');
        if (description && active) { description.textContent = active.dataset.galleryDescription || ''; description.hidden = !description.textContent; }
      };
      buttons.forEach(button => button.addEventListener('click', () => swap(button.dataset.galleryImage, button.dataset.imageAlt, button.dataset.mediaId)));
      section.querySelector('[data-zoom]')?.addEventListener('click', () => {
        if (!dialog || !image) return;
        const expanded = dialog.querySelector('img'); expanded.src = image.dataset.fullImage || image.src; expanded.alt = image.alt;
        dialog.showModal();
      });
      dialog?.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const form = section.querySelector('.syk-product-form');
      if (!form) return;
      const qty = form.querySelector('[name=quantity]');
      section.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
        const step = Number(qty.step) || 1;
        const min = Number(qty.min) || 1;
        const max = qty.max ? Number(qty.max) : Infinity;
        qty.value = String(Math.min(max, Math.max(min, (Number(qty.value) || min) + Number(button.dataset.quantity) * step)));
        qty.dispatchEvent(new Event('change', {bubbles: true}));
      }));
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const add = form.querySelector('[data-add-button]');
      form.querySelector('[data-variant-select]')?.addEventListener('change', event => {
        const variant = variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        section.querySelector('[data-variant-price]').textContent = variant.price;
        const compare = section.querySelector('[data-variant-compare]'); compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
        add.disabled = !variant.available; add.textContent = variant.available ? 'Add to Cart' : 'Sold out';
        section.querySelector('[data-stock-status]').textContent = (variant.available ? 'Available to order' : 'Currently sold out') + ' · Free US shipping. Taxes calculated at checkout.';
        qty.min = String(variant.min); qty.step = String(variant.step); qty.max = variant.max ? String(variant.max) : '';
        qty.value = String(variant.min);
        section.querySelectorAll('[data-variant-included]').forEach(el => {el.textContent = variant.included;});
        document.querySelectorAll('#SykContents [data-variant-included]').forEach(el => {el.textContent = variant.included;});
        if (variant.image) {
          [['syk-hero', variant.image], ['syk-contents', variant.contentsImage]].forEach(([id, src]) => {
            const thumb = Array.from(buttons).find(button => button.dataset.mediaId === id);
            if (!thumb || !src) return;
            thumb.dataset.galleryImage = src;
            thumb.dataset.imageAlt = section.querySelector('h1').textContent + ' — ' + variant.title;
            const preview = thumb.querySelector('img');
            if (preview) { preview.srcset = ''; preview.src = sizedImage(src, 180); preview.alt = thumb.dataset.imageAlt; }
          });
          swap(variant.image, section.querySelector('h1').textContent + ' — ' + variant.title, variant.mediaId);
          const configuration = document.querySelector('#SykContents figure img');
          if (configuration) {responsiveImage(configuration, variant.contentsImage || variant.image, '(min-width: 750px) 50vw, 100vw'); configuration.alt = section.querySelector('h1').textContent + ' — ' + variant.title;}
        }
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      });
      form.addEventListener('submit', async event => {
        if (event.submitter !== add || !window.fetch) return;
        event.preventDefault();
        if (add.disabled || !form.reportValidity()) return;
        const status = form.querySelector('[data-form-status]');
        const returnFocus = document.activeElement;
        add.disabled = true; add.textContent = 'Adding…'; status.textContent = '';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
          status.textContent = 'Added to your bag.';
          if (window.SykCommerce) {
            try { await window.SykCommerce.openCart({returnFocus}); }
            catch { window.location.assign(root + 'cart'); return; }
            const selectedVariant = variants.find(v => String(v.id) === String(form.querySelector('[name=id]').value));
            add.disabled = !selectedVariant?.available; add.textContent = add.disabled ? 'Sold out' : 'Add to Cart';
          } else window.location.assign(root + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Unable to add this item. Please try again.';
          add.disabled = false; add.textContent = 'Add to Cart';
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.syk-mega[open],.syk-mobile-menu[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.syk-mega[open],.syk-mobile-menu[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
})();
